<style scoped>
.max-width-100 {
  max-width: 100%;
}
</style>

<template>
  <div class="image">
    <viewer :options="options" @inited="inited" class="viewer" ref="viewer">
      <template>
        <img :src="stringSource" class="max-width-100">
      </template>
    </viewer>
  </div>
</template>

<script>

// Library
import 'viewerjs/dist/viewer.css'
import Viewer from "v-viewer/src/component.vue"

export default {
  name: 'ImgItem',
  components: {
    Viewer
  },
  props: {
    media: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      // Viewer
      options: { // Options for viewer
        navbar: false
      }
    }
  },
  computed: {
    // String
    stringSource() {
      return this.media.content;
    }
  },
  mounted() {

  },
  methods: {
    // Viewer
    inited(viewer) {
      this.$viewer = viewer;
    },
    show() {
      this.$viewer.show();
    },
  },
}
</script>
